import { render } from "./AdminWFHDetails.vue?vue&type=template&id=5d37936a&scoped=true"
import script from "./AdminWFHDetails.vue?vue&type=script&lang=js"
export * from "./AdminWFHDetails.vue?vue&type=script&lang=js"

import "./AdminWFHDetails.vue?vue&type=style&index=0&id=5d37936a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d37936a"]])

export default __exports__